<div *ngIf="auth && auth.user">
  <div class="search-form">
    <mat-form-field appearance="outline" class="m-2">
        <mat-label>Date From/Until</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="From" [(ngModel)]="dateFrom">
          <input matEndDate placeholder="Until" [(ngModel)]="dateUntil">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="search()" class="report-btn"> <mat-icon>search</mat-icon> </button>
    <button mat-raised-button color="primary" (click)="export()" class="report-btn"> <mat-icon>file_download</mat-icon> </button>

    <button mat-raised-button color="warn" (click)="searchDeleted()" class="report-btn"> <mat-icon>search</mat-icon> <mat-icon>delete</mat-icon> </button>

    <button mat-raised-button color="accent" (click)="refreshData()" class="report-btn"> <mat-icon>refresh</mat-icon> </button>
  </div>

  <div *ngIf="dataSource"  style="margin-top: 18px;">
    <mat-form-field class="filer">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)"  #input>
    </mat-form-field>
    
    <table mat-table [dataSource]="dataSource" matSort>
      
      <ng-container matColumnDef="memberId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> id </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.memberId}} </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.name}} </td>
      </ng-container>
  
      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.lastName}} </td>
      </ng-container>
      <ng-container matColumnDef="countryCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Country </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.countryCode}} </td>
      </ng-container>
    
      <ng-container matColumnDef="sex">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Sex </th>
        <td mat-cell *matCellDef="let element"> {{element.sex}} </td>
      </ng-container>

      <ng-container matColumnDef="age">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Age </th>
        <td mat-cell *matCellDef="let element"> {{element.age}} </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef> Email </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.email}} </td>
      </ng-container>

      <ng-container matColumnDef="sourceDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Marketing Channel </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.sourceDescription}} </td>
      </ng-container>
    
      <ng-container matColumnDef="dateTimeEntered">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date Time </th>
        <td mat-cell *matCellDef="let element"> {{element.dateTimeEntered | date :'dd-MM-yy HH:mm'}} </td>
      </ng-container>

      <ng-container matColumnDef="productsStartingPrice">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Starting Price </th>
        <td mat-cell *matCellDef="let element"> {{element.productsStartingPrice}} </td>
      </ng-container>

      <ng-container matColumnDef="productsFinalPrice">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Final Price </th>
        <td mat-cell *matCellDef="let element"> {{element.productsFinalPrice}} </td>
      </ng-container>

      <ng-container matColumnDef="paymentAmount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Payments </th>
        <td mat-cell *matCellDef="let element"> {{element.paymentAmount}} </td>
      </ng-container>


      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="!isMemberTrash" mat-button (click)="delete(element); $event.stopPropagation()"><mat-icon>delete</mat-icon></button>
          <button *ngIf="isMemberTrash" mat-button (click)="restoreMember(element); $event.stopPropagation()"><mat-icon>undo</mat-icon></button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="showMember(row)"></tr>
    
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
      </tr>

    </table>
    <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
  </div>
</div>
